// For main menu bg height
var headerNav = document.querySelector('header.header--top-left nav.header__inline-menu');
headerNav.style.cssText += '--nav-height:'+headerNav.offsetHeight+'px';

// For all external links
var thLinks = document.links;
for (let i = 0, linksLength = thLinks.length; i < linksLength; i++) {
  if (thLinks[i].hostname !== window.location.hostname && thLinks[i].hostname !== 'shopify.com' && thLinks[i].href !== 'javascript:;' && thLinks[i].href !== '#') {
    thLinks[i].target = '_blank';
    thLinks[i].rel = 'noreferrer noopener';
  }
}

// Make dropdown menu appears on hover
if (!navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi|Tablet|iPad/i)) {
  document.querySelectorAll('.header__inline-menu [id^="Details-"] summary').forEach((summary) => {
    summary.addEventListener('mouseenter', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      summary.parentElement.setAttribute('open', 'true');
    });
    summary.addEventListener('mouseleave', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      summary.parentElement.removeAttribute('open');
    });
    if (summary.parentElement.querySelector('.mega-menu__content')) {
      summary.parentElement.querySelector('.mega-menu__content').addEventListener('mouseenter', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        summary.parentElement.setAttribute('open', 'true');
      });
      summary.parentElement.querySelector('.mega-menu__content').addEventListener('mouseleave', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        summary.parentElement.removeAttribute('open');
      });
    }
  });
}

// filters to show always open (not collapsed)
/*window.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('facet-filters-form details.facets__disclosure-vertical').forEach(item => {
    if (!item.hasAttribute('open')) {
      item.querySelector('summary').click()
    }
  })
});*/

// html anchor hash tag smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({behavior: 'smooth'});
    });
});

//
/*
window.addEventListener('load', function() {
  let iWishAddBtnb = document.querySelector('.iwish-app-block-product .iWishAdd');
  if (iWishAddBtnb) {
    if (iWishAddBtnb.classList.contains('iwishAdded')) {
      console.log('The "active" class is added.');
      document.querySelector('.template-product .wish-list-btn button').classList.add('active');
    } else {
      console.log('The "active" class is not added.');
      document.querySelector('.template-product .wish-list-btn button').classList.remove('active');
    }
  }
});

document.querySelector('.template-product .wish-list-btn button').addEventListener('click', function (e) {
  e.preventDefault();
  let iWishAddBtnb = document.querySelector('.iwish-app-block-product .iWishAdd');
  if (iWishAddBtnb) {
    iWishAddBtnb.click();

    if (iWishAddBtnb.classList.contains('iwishAdded')) {
      console.log('The "active" class is added.');
      this.classList.add('active');
    } else {
      console.log('The "active" class is not added.');
      this.classList.remove('active');
    }
  }
});*/

// for back In Stock Btn trigar
let backInStockBtn = document.querySelector('.product__info-container .product_price_hide');
if (backInStockBtn) {
  backInStockBtn.addEventListener('click', function (e) {
    e.preventDefault();
    let bISTrigger = document.querySelector('#BIS_trigger');
    if (bISTrigger) {
      bISTrigger.click();
    }
  })
};




